export class UploadBuyerIdTransactionsError extends Error {}
